const BASE_URL = '/'
const SIGN_IN = BASE_URL
const HOME = `${BASE_URL}home`
const MICROSOFT_CALLBACK = `${BASE_URL}callback`
const ADMIN = `${BASE_URL}admin`
const ADMIN_USERS = `${ADMIN}/users`
const PARAMS = `${BASE_URL}params`
const PARAMS_BOARDS = `${PARAMS}/boards`
const PARAMS_GROUPS = `${PARAMS}/groups`
const PARAMS_SURVEYS = `${PARAMS}/surveys`
const PARAMS_SURVEYS_DETAILS = `${PARAMS_SURVEYS}/:surveyId`
const PARAMS_DISTRIBUTIONS = `${PARAMS}/distributions`
const REGISTERS = `${BASE_URL}registers`
const REGISTERS_TICKETS = `${REGISTERS}/tickets`
const REGISTERS_CONTACTS = `${REGISTERS}/contacts`
const DISTRIBUTIONS = `${BASE_URL}distributions`
const DISTRIBUTIONS_DETAILS = `${DISTRIBUTIONS}/:distributionId`
const REPORTS = `${BASE_URL}reports`
const REPORTS_GENERALS = `${REPORTS}/generals`
const REPORTS_GRIP = `${REPORTS}/grip`
const SURVEYS = `${BASE_URL}surveys`
const SURVEYS_USER = `${SURVEYS}/:uuid`
const UNAUTHORIZED = `${BASE_URL}not-authorized`

export default {
  BASE_URL,
  SIGN_IN,
  HOME,
  MICROSOFT_CALLBACK,
  ADMIN_USERS,
  PARAMS_BOARDS,
  PARAMS_GROUPS,
  PARAMS_SURVEYS,
  PARAMS_SURVEYS_DETAILS,
  PARAMS_DISTRIBUTIONS,
  REGISTERS_TICKETS,
  REGISTERS_CONTACTS,
  DISTRIBUTIONS,
  DISTRIBUTIONS_DETAILS,
  REPORTS_GENERALS,
  REPORTS_GRIP,
  SURVEYS_USER,
  UNAUTHORIZED,
}
